export function getFirstMatchingParent(
  start: HTMLElement,
  predicate: (ele: HTMLElement) => boolean
): HTMLElement {
  let element = start;
  while (element !== document && element) {
    if (predicate(element)) return element;

    element = element.parentNode;
  }

  return null;
}

export function createElement(
  tagName: string,
  attributes: object = {},
  children: Array<HTMLElement> = []
) {
  const ele = document.createElement(tagName);

  for (let a in attributes) {
    if (a === '__text') {
      ele.innerText = attributes[a];
    } else {
      ele.setAttribute(a, attributes[a]);
    }
  }

  children.forEach(c => ele.appendChild(c));

  return ele;
}

export function prependChild(parent: HTMLElement, child: HTMLElement) {
  if (parent.firstChild) {
    parent.insertBefore(child, parent.firstChild);
  } else {
    parent.appendChild(child);
  }
}
